import { render, staticRenderFns } from "./BubbleControls.vue?vue&type=template&id=542013a3&scoped=true&"
import script from "./BubbleControls.vue?vue&type=script&lang=js&"
export * from "./BubbleControls.vue?vue&type=script&lang=js&"
import style0 from "./BubbleControls.vue?vue&type=style&index=0&id=542013a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542013a3",
  null
  
)

export default component.exports